module.exports = __webpack_public_path__ + "img/6-3_Filter.3f84bd36.png";